var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4762 16.4643C20.7417 16.4643 17.7143 19.4917 17.7143 23.2262C17.7143 26.9607 20.7417 29.9881 24.4762 29.9881C28.2107 29.9881 31.2381 26.9607 31.2381 23.2262C31.2381 19.4917 28.2107 16.4643 24.4762 16.4643ZM16 23.2262C16 18.5449 19.7949 14.75 24.4762 14.75C29.1575 14.75 32.9524 18.5449 32.9524 23.2262C32.9524 27.9075 29.1575 31.7024 24.4762 31.7024C19.7949 31.7024 16 27.9075 16 23.2262Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4574 28.2076C29.7921 27.8729 30.3348 27.8729 30.6695 28.2076L35.7489 33.287C36.0836 33.6217 36.0836 34.1644 35.7489 34.4991C35.4142 34.8339 34.8715 34.8339 34.5367 34.4991L29.4574 29.4198C29.1226 29.085 29.1226 28.5423 29.4574 28.2076Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1303 26.942C31.6029 26.9701 31.9632 27.376 31.935 27.8485C31.8898 28.609 31.7376 29.3462 31.1925 29.8861C30.6635 30.4102 29.9214 30.5876 29.15 30.6804C28.68 30.7369 28.2532 30.4017 28.1966 29.9317C28.1401 29.4617 28.4753 29.0349 28.9453 28.9783C29.6602 28.8924 29.8919 28.7615 29.9861 28.6682C30.0643 28.5908 30.1848 28.4015 30.2238 27.7467C30.2519 27.2741 30.6578 26.9138 31.1303 26.942Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3927e2cb9b65d365a401b33ff1b4e8c8.svg";
export { ForwardRef as ReactComponent };